import React from 'react';
import { useHistory } from 'react-router-dom'
import { Grid, Link, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      backgroundColor: "#191919",
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    titleFooter : {
      color:"white", 
      marginBottom:"15px", 
      borderBottom: "1px solid white", 
      paddingBottom: "5px",
      fontWeight: "500"
    }
  }));
 

const ContactForm = ({ t }) => {
    const classes = useStyles();
    const history = useHistory()
    const gotoTermsPage = (e) => {
      history.push('/termscondition') 
      };

    const gotoPolicyPage = (e) => {
      history.push('/privacypolicy') 
    };
    
    return (
        <div className={classes.root}>
          <Grid container style={{ marginTop:"50px", justifyContent: "center" }}>
            <Box px={8} width="100%">
            <Grid item xs={12} md={12}>
              <Grid container spacing={10}>
                  <Grid item xs={12} md={3}>
                    <img src='footer-logo-quickey.png' width="75%"/>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <p className={classes.titleFooter}>{t('footer.contact')}</p>
                    <p className="text-grey" style={{ marginBottom:"10px", lineHeight: "1.8" }}>
                    <span className="reguler text-white">Binc Teknologi Grup, PT</span> <br/>
                    Treasury Tower, Lt 31 <br/>
                    Jl. Jend. Sudirman Kav. 52-53 <br/>
                    Jakarta 12190 <br/>
                    contact@getquickey.com</p>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <p className={classes.titleFooter}>Frameworks & SDKs</p>
                    <Grid container>
                      <Grid item xs={12} md={6}>
                        <p className="mb-2 text-grey"><a href='https://quickey-docs.netlify.app/nodejs-sdk'>Node.js</a></p>
                        <p className="mb-2 text-grey"><a href='https://quickey-docs.netlify.app/python-sdk'>Python</a></p>
                        <p className="mb-2 text-grey"><a href='https://quickey-docs.netlify.app/php-sdk'>PHP</a></p>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <p className="mb-2 text-grey"><a href='https://quickey-docs.netlify.app/go-sdk'>Go</a></p>
                        <p className="mb-2 text-grey"><a href='https://quickey-docs.netlify.app/ruby-sdk'>Ruby</a></p>
                        <p className="mb-2 text-grey"><a href='https://quickey-docs.netlify.app/react-sdk'>React</a></p>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid className="d-flex" direction="column" item xs={12} md={3}>
                    <p href="#" className={classes.titleFooter}>Support</p>
                    <a className="mb-2 text-decoration-none text-grey" onClick={gotoTermsPage}>{t('footer.terms')}</a>
                    <a className="mb-2 text-decoration-none text-grey" onClick={gotoPolicyPage}>{t('footer.privacyPolicy')}</a>
                  </Grid>
              </Grid>
            </Grid>
            <p className="font-size-14" style={{ color:"#d2d2d2", margin:'.75rem 0 3rem', textAlign: 'center' }} color="textSecondary">
            Made with ❤️ in &thinsp;<span><img src='id-flag.png' style={{width: "16px",marginTop: "-5px"}}/></span>&thinsp;. {t('footer.copyRight')}{'© '}
              <Link color="inherit" href="https://getquickey.com/">
                Quickey
              </Link>{' '}
              {new Date().getFullYear()}
              {' '}
              - PT. Binc Teknologi Grup
            </p>
            </Box>
          </Grid>          
      </div>
    )
}

export default withTranslation()(ContactForm);